import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { moduli } from '../../config';
import { PartneriService } from './partneri.service';

@Component({
  selector: 'app-partneri',
  templateUrl: './partneri.component.html',
  styleUrls: ['./partneri.component.scss'],
  providers: [PartneriService],
})
export class PartneriComponent implements OnInit {
  @ViewChild('tablicaPartneri', { static: false })
  dataPartneri: DxDataGridComponent;

  startEditAction: string = 'click';
  selectTextOnEditStart: boolean = true;
  partneri: any;
  grupe: any;
  prikazi: any = [
    {idprikaz: 1, pr_naziv: 'DA'},
    {idprikaz: 0, pr_naziv: ''}
  ];
  prijevoznikArray: any = [
    {idprikaz: 1, pr_naziv: 'DA'},
    {idprikaz: 0, pr_naziv: 'NE'}
  ];

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(
    private partneriService: PartneriService,
    private router: Router
  ) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }
    this.dohvatiGrupePartnera();

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().partneri;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.partneriService.dohvatiPartnere({}).subscribe((res) => {
      console.log(res);
      this.partneri = [];
      for (let data of res.data) {
        this.partneri.push({
          id: data.pa_id,
          sifra: data.pa_sifra,
          naziv: data.pa_naziv,
          otprema_mobitel: data.pa_otprema_mobitel,
          utovarDan: data.pa_danazautovoar == 0 ? null : data.pa_danazautovoar,
          grupaId: data.idpartnergrupa,
          grupa: data.pg_naziv,
          prijevoznik: data.pa_prijevoznik
        });
      }
      // console.log(this.partneri);
    });
  }

  dohvatiGrupePartnera() {
    this.grupe = [];
    this.partneriService.dohvatiGrupePartnera({}).subscribe((res) => {
      console.log(res);
      this.grupe = res.data;
    });
  }

  onRowUpdated(e) {
    console.log(e);
    let objekt = {
      idpartner: e.data.id,
      danzautovar: e.data.utovarDan,
      idpartnergrupa: e.data.grupaId,
      pa_prijevoznik: e.data.prijevoznik,
      pa_otprema_mobitel: e.data.otprema_mobitel
    };
    console.log(objekt);
    this.partneriService.partnerUredi(objekt).subscribe((res) => {
      console.log(res);
      if (res.success == true) {
        this.dataPartneri.instance.refresh();
      }
    });
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }
}
